import React from 'react'

import DataBridgeSectionRowContainer from '../components/DataBridgeSectionRowContainer'

const COMMON_ROW_COUNT = 2

export default function IndeterminateDestination() {
  return (
    <>
      {Array.from({ length: COMMON_ROW_COUNT }).map((_, index) => (
        <DataBridgeSectionRowContainer
          key={`indeterminate-destination-${index}`}
          data-testid="indeterminateDestinationRow"
        >
          <div className="flex flex-1 flex-col space-y-1">
            <div className="bg-background-400 h-5 w-1/5 animate-pulse rounded" />
            <div className="bg-background-400 h-5 w-2/5 animate-pulse rounded" />
          </div>
        </DataBridgeSectionRowContainer>
      ))}
    </>
  )
}
